<template>
  <TableBox class="amount-box _mb-60">
    <TableBody>
      <TableRow>
        <TableData :has-error="errors['inputAmount']">
          <div class="flex">
            <div class="input-center">
              <InputGroup :errors="errors" :prop-names="['inputAmount']">
                <InputgroupAppend>
                  <span class="ttl _mr-10">お借り入れ金額</span>
                  <InputItem
                    id="amount"
                    :value="modelValue"
                    type="text"
                    variant="-sm"
                    :maxlength="3"
                    @input="updateValue"
                  >
                  </InputItem>
                  <InputAppend>万円</InputAppend>
                </InputgroupAppend>
              </InputGroup>
            </div>
          </div>
        </TableData>
      </TableRow>
    </TableBody>
  </TableBox>
</template>

<script>
import InputItem from "@/components/input/InputItem";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputAppend from "@/components/input/InputAppend";
import TableRow from "@/components/tables/TableRow";
import TableData from "@/components/tables/TableData";
import TableBody from "@/components/tables/TableBody";
import TableBox from "@/components/tables/TableBox";

export default {
  name: "AmountBox",
  components: {
    TableBox,
    TableBody,
    TableData,
    TableRow,
    InputItem,
    InputGroup,
    InputgroupAppend,
    InputAppend,
  },
  props: {
    modelValue: { type: String, default: "" },
  },
  emits: ["update:modelValue", "input", "change"],
  data() {
    return {
      errors: {},
    };
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("update:modelValue", val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.amount-box {
  border-collapse: separate;
  border: 1px solid $primary;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  :deep(.table-data) {
    width: 100%;
    text-align: center;
    border: none;
    > .flex {
      justify-content: center;
      > .input-center {
        min-width: 280px;
        @include mq-up(md) {
          min-width: 400px;
        }
        .ttl {
          font-weight: bold;
          font-size: 14px;
          @include mq-up(md) {
            font-size: 16px;
          }
        }
        .input-item {
          &.-sm {
            @include mq-down(md) {
              max-width: 110px;
            }
          }
        }
      }
    }
  }
  @include mq-up(md) {
    padding-top: 4px;
    padding-bottom: 7px;
  }
}
</style>
